import { render } from "./File.vue?vue&type=template&id=3f95fb8a&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=3f95fb8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f95fb8a"

export default script